import styled from 'styled-components/macro';
import { spacing01, spacing04 } from '../../styling/spacing';
import { FieldContainer } from './FormField';

export const FormFieldRow = styled.div<{ $minimumFieldWidth?: string; type?: 'fit' | 'fill' }>`
  display: grid;
  grid-template-columns: repeat(
    ${props => (props.type === 'fit' && 'auto-fit') || (props.type === 'fill' && 'auto-fill') || 'auto-fit'},
    minmax(
      ${props => props.$minimumFieldWidth || '100px'},
      ${props => (props.type === 'fit' && '1fr') || (props.type === 'fill' && '300px') || '1fr'}
    )
  );
  grid-gap: ${spacing04} ${spacing01};
  margin-bottom: ${spacing04};

  ${FieldContainer} {
    display: inline-block;
    margin: 0;
  }

  &:empty {
    margin: 0;
  }
`;

export const WideGridContainer = styled.div`
  grid-column: span 2;
`;

export const GridContainer = styled.div`
  grid-column: span 1;
`;
